import { render, staticRenderFns } from "./DadosEstatisticosBiblioteca.vue?vue&type=template&id=7a9441fa&"
import script from "./DadosEstatisticosBiblioteca.vue?vue&type=script&lang=js&"
export * from "./DadosEstatisticosBiblioteca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports